// @flow
import React from 'react';
import './icon.css';

const url = require('./icon.svg');

type Props = {
    icon: string,
    id?: string,
    style: ?Object,
};

type State = {
    id?: string,
    style: ?Object,
};

export default class Icon extends React.PureComponent<Props, State> {
    static defaultProps = {
        id: '',
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            id: props.id,
            style: props.style,
        };
    }

    render() {
        if (this.props.icon === 'video') {
            return (
                <svg
                    className="icon-gwa"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-labelledby="title"
                >
                    <title id="title">Video</title>
                    <path
                        d="M21,19 L21,5 C21,3.9 20.1,3 19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21
                        C20.1,21 21,20.1 21,19 Z"
                        id="camera"
                        fill="#46BC98"
                        fillRule="nonzero"
                    />
                    <path
                        d="M16.1111111,11.25 L16.1111111,8.72222222 C16.1111111,8.325 15.7861111,8 15.3888889,8
                        L6.72222222,8 C6.325,8 6,8.325 6,8.72222222 L6,15.9444444 C6,16.3416667 6.325,16.6666667
                        6.72222222,16.6666667 L15.3888889,16.6666667 C15.7861111,16.6666667 16.1111111,16.3416667
                        16.1111111,15.9444444 L16.1111111,13.4166667 L19,16.3055556 L19,8.36111111 L16.1111111,11.25 Z"
                        id="Shape"
                        fill="#FFFFFF"
                        fillRule="nonzero"
                    />
                </svg>
            );
        }
        return (
            <svg
                viewBox="0 0 24 24"
                className={`icon-gwa icon-${this.props.icon}`}
                id={this.state.id || ''}
                style={this.state.style}
            >
                <use xlinkHref={`${url}#icon-${this.props.icon}`} />
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// src/components/ui/icon/icon.js